import React, { useEffect, useState } from "react"
import { Link, useNavigate, useLocation } from "react-router-dom"
import { CSVLink } from "react-csv"
import { FaDownload } from "react-icons/fa"
import { getExportsList } from "../../requesters/Backend/ProgramRequester"
import Pagination from "../Pagination"

const PER_PAGE = 25

function BackendExportsDashboard({ baseUrl, currentUser }) {
  const location = useLocation()
  const navigate = useNavigate()
  const { pathname, search } = location
  const initialParams = new URLSearchParams(location.search)

  const [list, setList] = useState([])
  const [total, setTotal] = useState(0)
  const [page, setPage] = useState(parseInt(initialParams.get("page") || "1", 10))

  useEffect(() => {
    const params = { page, per_page: PER_PAGE }
    getExportsList(baseUrl, params, currentUser).then(res => {
      setList(res?.response || [])
      setTotal(parseInt(res?.headers?.["x-total"] || "0", 10))
      return null
    }).catch(err => {
      // eslint-disable-next-line no-console
      console.log(err)
    })
  }, [page, baseUrl, currentUser])

  useEffect(() => {
    const params = new URLSearchParams()
    params.set("page", String(page))
    const next = `?${params.toString()}`
    if (search === next) return
    navigate({ pathname, search: next }, { replace: true })
  }, [page, navigate, pathname, search])

  return (
    <div className="content">
      <div className="container-fluid">
        <div className="page-header">
          <div className="d-flex justify-content-between align-items-center">
            <h2>Recent Exports</h2>
          </div>
        </div>
        {list.length > 0 ? (
          <>
            <div className="list-table-wrap">
              <div className="table-responsive">
                <table className="table list-table">
                  <thead>
                    <tr>
                      <th>Time</th>
                      <th>Program Name</th>
                      <th>Initiated by</th>
                      <th>File Name</th>
                      <th>Status</th>
                      <th>Download</th>
                    </tr>
                  </thead>
                  <tbody>
                    {list.map(item => (
                      <tr key={item.id}>
                        <td className="text-nowrap cell-muted">{item.created_at}</td>
                        <td><Link to={`/backend/programs/${item.calculator?.program_id}`}>{item.calculator?.program_name}</Link></td>
                        <td>{item.author}</td>
                        <td className="cell-muted">{item.file_name}</td>
                        <td>{item.status ? <span className="cell-badge">{item.status}</span> : "—"}</td>
                        <td className="text-center">
                          {item.download_url ? (
                            <a
                              className="text-muted"
                              href={item.download_url}
                              title="Download"
                              aria-label={`Download ${item.file_name || "CSV"}`}
                              download={item.file_name}>
                              <FaDownload aria-hidden="true" />
                            </a>
                          ) : (
                            !!item.data && (
                              <CSVLink
                                className="text-muted"
                                data={JSON.parse(item.data)}
                                filename={item.file_name}
                                title="Download"
                                aria-label={`Download ${item.file_name || "CSV"}`}>
                                <FaDownload aria-hidden="true" />
                              </CSVLink>
                            )
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
            <Pagination
              totalRows={total}
              pageChangeHandler={setPage}
              rowsPerPage={PER_PAGE}
              initialPage={page} />
          </>
        ) : (
          <p className="text-muted mt-3 mb-0 text-center">No exports found</p>
        )}
      </div>
    </div>
  )
}

export default BackendExportsDashboard
